import { useContent } from "@/content/ContentProvider";
import React, { useEffect, useRef, useState } from "react";

// Trailing cursor: small inverting dot, grows over links, shows a label over [data-cursor] elements.
export default function Cursor() {
  const {
    text: cmsText
  } = useContent();
  const el = useRef(null);
  const [mode, setMode] = useState({
    m: "idle",
    label: ""
  });
  const last = useRef("idle|");
  useEffect(() => {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return undefined;
    const node = el.current;
    let x = -100,
      y = -100,
      cx = -100,
      cy = -100,
      raf = 0;
    const move = e => {
      x = e.clientX;
      y = e.clientY;
      node.style.opacity = 1;
      const t = e.target.closest?.("[data-cursor],a,button,[role=button],[role=tab],input,textarea,select,label");
      const next = !t ? {
        m: "idle",
        label: ""
      } : t.dataset.cursor ? {
        m: "label",
        label: t.dataset.cursor
      } : {
        m: "link",
        label: ""
      };
      const key = `${next.m}|${next.label}`;
      if (key !== last.current) {
        last.current = key;
        setMode(next);
      }
    };
    const leave = () => {
      node.style.opacity = 0;
    };
    const loop = () => {
      cx += (x - cx) * 0.2;
      cy += (y - cy) * 0.2;
      node.style.transform = `translate3d(${cx}px,${cy}px,0) translate(-50%,-50%)`;
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener("pointermove", move, {
      passive: true
    });
    document.documentElement.addEventListener("pointerleave", leave);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("pointermove", move);
      document.documentElement.removeEventListener("pointerleave", leave);
      cancelAnimationFrame(raf);
    };
  }, []);
  const size = mode.m === "label" ? 84 : mode.m === "link" ? 40 : 10;
  return <div ref={el} aria-hidden="true" data-testid="cursor" className="pointer-events-none fixed left-0 top-0 z-[100] opacity-0">
      <div style={{
      width: size,
      height: size
    }} className={`flex items-center justify-center rounded-full text-[11px] font-medium transition-[width,height,background-color,border-color] duration-300 ease-[cubic-bezier(.15,.9,.34,.95)] ${mode.m === "label" ? "bg-black text-white" : mode.m === "link" ? "border-[1.5px] border-white bg-transparent mix-blend-difference" : "bg-white mix-blend-difference"}`}>
        {mode.m === cmsText("Cursor.Cursor.label.64c653") ? mode.label : null}
      </div>
    </div>;
}
